import React from 'react';
import { Section, SectionHeading } from '../ui/Section';
import { ButtonLink } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { VehicleCard } from '../VehicleCard';
import { useVehicles } from '../../contexts/VehiclesContext';
export function Oportunidades() {
  const {
    vehicles
  } = useVehicles();
  const oportunidades = vehicles.filter(v => v.oportunidad).slice(0, 3);
  if (oportunidades.length === 0) return null;
  return <Section id="oportunidades" data-id="element-320" data-mp="1o7ji8kn1od2">
      <Reveal data-id="element-321" data-mp="6l7qclpbav58">
        <SectionHeading title="Oportunidades VCARS" lead="Unidades seleccionadas con condiciones especiales por tiempo limitado." action={<ButtonLink to="/catalogo?oportunidad=1" size="lg" data-id="element-323" data-mp="gjnims02sagb">
              Ver todas las oportunidades
            </ButtonLink>} data-id="element-322" data-mp="6ky2b3ntuy26" />
      </Reveal>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-324" data-mp="1mz7mdll1e0n7">
        {oportunidades.map((v, i) => <Reveal key={v.id} delay={Math.min(i, 3) * 0.04} className="h-full" data-id="element-325" data-mp="1rwzh0nd2g0v3" data-mpi={i}>
            <VehicleCard vehicle={v} data-id="element-326" data-mp="2qzl1ae24f9i2" />
          </Reveal>)}
      </div>
    </Section>;
}